/**
 * @generated SignedSource<<5070d8ae2a07432b3d55f66cb3e80fcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnassignApplianceInput = {
  applianceId: string;
  clientId: string;
};
export type ClientAssignee_unassignAppliance_Mutation$variables = {
  input: UnassignApplianceInput;
};
export type ClientAssignee_unassignAppliance_Mutation$data = {
  readonly unassignAppliance: {
    readonly appliance: {
      readonly assignee: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
    };
  } | null;
};
export type ClientAssignee_unassignAppliance_Mutation = {
  response: ClientAssignee_unassignAppliance_Mutation$data;
  variables: ClientAssignee_unassignAppliance_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnassignAppliancePayload",
    "kind": "LinkedField",
    "name": "unassignAppliance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "appliance",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "assignee",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientAssignee_unassignAppliance_Mutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientAssignee_unassignAppliance_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "015e5ce36c1877a43a75b4c5a0c4c064",
    "id": null,
    "metadata": {},
    "name": "ClientAssignee_unassignAppliance_Mutation",
    "operationKind": "mutation",
    "text": "mutation ClientAssignee_unassignAppliance_Mutation(\n  $input: UnassignApplianceInput!\n) {\n  unassignAppliance(input: $input) {\n    appliance {\n      id\n      assignee {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ddda5e6678fa2a5eb642dd2a78915cc";

export default node;
